/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */

import SSBarCartesian from './ssbarcartesian';
import Bar2DDataset from '../_internal/datasets/bar2d';

/**
 * chart API of the Bar2Dn chart
 */
class Bar2D extends SSBarCartesian {
  /**
   * constructor fn
   */
  constructor () {
    super();
    this.isBar = true;
  }
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'Bar2D';
  }

  /**
   * Sets the type of the component
   * @return {string} type
   */
  getType () {
    return 'chartAPI';
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'Bar2D';
  }
  /**
   * This set the default configuration for this chart
   */
  __setDefaultConfig () {
    super.__setDefaultConfig();
    this.config.friendlyName = 'Bar Chart';
    this.config.singleseries = true;
    this.config.defaultDatasetType = 'bar2d';
    this.config.enablemousetracking = true;
  }
  /**
   * This method return the dataset definations for this charts
   * @return {class} bar2d dataset definitions
   */
  getDSdef () {
    return Bar2DDataset;
  }
  /**
   * This method return the dataset-group definations for this charts
   */
  getDSGroupdef () {
    // this fn overrides
  }
}
export default Bar2D;
